import type { Email } from '@/types/email';

export function buildReplyQuotedBody(email: Email): string {
  const toLine = email.to?.length
    ? email.to.map((t) => t.email).filter(Boolean).join(', ')
    : '—';
  return `<br/><br/><hr/><p><strong>Mensagem original</strong></p><p>De: ${email.from.name} &lt;${email.from.email}&gt;<br/>Para: ${toLine}<br/>Assunto: ${email.subject}</p>${email.body}`;
}

export function buildForwardedBody(email: Email): string {
  const toLine = email.to?.length
    ? email.to.map((t) => t.email).filter(Boolean).join(', ')
    : '—';
  return `<br/><br/><hr/><p><strong>Mensagem encaminhada</strong></p><p>De: ${email.from.name} &lt;${email.from.email}&gt;<br/>Para: ${toLine}<br/>Assunto: ${email.subject}</p>${email.body}`;
}
